/**
 * Route paths
 */
export default {
    ROOT: '/',
    OIDC_AUTHORIZE: '/oidc/authorize',
    OIDC_AUTHENTICATE: '/oidc/authenticate',
    OAUTH2_AUTHORIZE: '/oauth2/authorize',
    OAUTH2_AUTHENTICATE: '/oauth2/authenticate',
    DASHBOARD: '/dashboard/:sportId?',
    CATEGORIES: '/categories',
    DOSSIER: '/leveldossier',
    ADMIN: '/admin',
    EXCEL_IMPORT: '/admin/dashboard',
};
